module.exports = __webpack_public_path__ + "static/water-f5bb82cfefd3e9e4091f45330403f130.wav";